// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p5Bll","pageTitle":"styles_pageTitle__XuAkZ","actionsContainer":"styles_actionsContainer__cUhSc","tableContainer":"styles_tableContainer__d3Pgs"};